import { render } from "./EditarPreguntas.vue?vue&type=template&id=4e6b9513"
import script from "./EditarPreguntas.vue?vue&type=script&lang=js"
export * from "./EditarPreguntas.vue?vue&type=script&lang=js"

import "./EditarPreguntas.vue?vue&type=style&index=0&id=4e6b9513&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__